import Vue from 'vue';
import VueRouter from 'vue-router'
import Catalog from './catalog.vue';
import i18n from './plugins/i18n.js';
// Swiper
import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css'

Vue.use(VueRouter)

export default function init(locale, data, checkout_url) {
    i18n.locale = locale;
    window.catalog = new Vue({
        el: '#vue-catalog',
        data: {
            catalog: data.catalog,
            checkout_url: checkout_url,
            cartItems: [],
            combinations: data.combinations
        },
        render: function (createElement){
           return createElement(Catalog, {
                props: {
                    categories: this.catalog,
                    combinations: this.combinations,
                    checkoutUrl: this.checkout_url,
                    cartItems: this.cartItems
                }
            })
        },
        // template: '<Catalog v-bind:categories="catalog" :combinations="combinations" :checkoutUrl="checkout_url" :cartItems="cartItems"/>',
        components: {
            Catalog,
            VueAwesomeSwiper
        },
        i18n
    });
}
